<script>
import { mapState } from 'vuex'

import { CountryEnum, ModeEnum } from '../store/modules/settings/types'
import SingleSelectedItemList from './diagnosis-lists/automation-mode/SingleSelectedItemList.vue'

export default {
  components: {
    'single-selected-item-list': SingleSelectedItemList,
  },
  props: {
    appSettings: { type: Object, required: true },
    rumId: { type: Number, required: true },
    rumPredictedLabels: { type: Array, required: true },
    diagnosisGroup: { type: Object, default: null },
    healthData: { type: Object, required: true },
    selection: { type: Object, default: null },
    isLoading: { type: Boolean, default: false },
    isProposal: { type: Boolean, default: false },
    suggestionJustifications: { type: Object, default: null },
  },
  emits: ['make-selection'],
  data() {
    return {
      mode: ModeEnum.AUTOMATION,
      CountryEnum,
    }
  },
  computed: {
    ...mapState({
      pmsiCountry: (state) => state.settings.pmsi.country,
    }),
    displayedAssociatedDiags() {
      return (this.diagnosisGroup.associatedDiags ?? [])
        .filter((das) => !das.disabled)
        .map((das) => das.associatedDiagnosis)
    },
  },
}
</script>

<template>
  <div class="card-container">
    <single-selected-item-list
      :app-settings="appSettings"
      :rum-id="rumId"
      :diagnosis-group="diagnosisGroup"
      :selection="selection"
      :is-loading="isLoading"
      :health-data="healthData"
      :rum-predicted-labels="rumPredictedLabels"
      :suggestion-justifications="suggestionJustifications"
      :is-proposal="isProposal"
      class="principal-diagnosis-group mb-3"
      type="DP"
      @make-selection="(selection) => $emit('make-selection', selection)"
    />
    <single-selected-item-list
      v-if="pmsiCountry === CountryEnum.CH || diagnosisGroup.currentDR || (diagnosisGroup.currentDP && diagnosisGroup.currentDP.reference[0] === 'Z')"
      :app-settings="appSettings"
      :rum-id="rumId"
      :diagnosis-group="diagnosisGroup"
      :selection="selection"
      :is-loading="isLoading"
      :health-data="healthData"
      :rum-predicted-labels="rumPredictedLabels"
      :suggestion-justifications="suggestionJustifications"
      :is-proposal="isProposal"
      class="related-diagnosis-group mb-3"
      type="DR"
      @make-selection="(selection) => $emit('make-selection', selection)"
    />
    <div
      v-if="displayedAssociatedDiags.length"
      class="associated-diagnosis-group mb-3"
    >
      <div
        class="card diagnosis-card"
        :class="[isProposal ? 'col-12' : 'col-6', { highlighted: !isProposal }]"
      >
        <div class="card-body">
          <h1 class="associated-title card-title d-flex align-items-center">
            <span>{{ $t('diagnosis.DAS') }}</span>
            <small class="ms-1 fs-6">- {{ isProposal ? $t('stayDisplayer.mco.diagnosisStatus.proposal') : $t('stayDisplayer.mco.diagnosisStatus.current') }}</small>
          </h1>
        </div>
        <div class="card-body">
          <div class="row g-0">
            <div
              v-for="(das, idx) in displayedAssociatedDiags"
              :key="das.reference"
              class="mb-1"
              :class="isProposal ? 'col-12' : ['col-6', { 'ps-1': idx % 2, 'pe-1': (idx - 1) % 2 }]"
            >
              <div class="card-body diagnosis-title p-1">
                <h2 :title="das.description">
                  {{ das.reference }}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.associated-title {
  font-size: 2rem;
}

h2 {
  font-size: 1.1rem;
}
</style>
